import { mapState } from 'vuex';

import { Errors } from '@/enums/errors.enum';
import { tryParseInt } from '@/utils/number';

import { formMixin } from './form';
import { modalMixin } from './modal';
import { notificationsMixin } from './notifications';

/**
 * Mixin zarządzania modelem
 *
 * @export
 * @param {string} moduleName - nazwa modułu
 * @param {Object} messages - treści notyfikacji
 * @param {string} [messages.formError] - treść notyfikacji o błędzie walidacji
 * @returns
 */
export function manageMixin(moduleName, messages) {
  return {
    mixins: [formMixin, notificationsMixin, modalMixin],
    data() {
      return {
        model: {}
      };
    },
    props: {
      // Identyfikator edytowanej encji
      id: {
        type: Number,
        required: false,
        default: undefined
      }
    },
    methods: {
      // @vuese
      // Funkcja mapująca model przed zapisem
      prepareModel(model) {
        return model;
      },
      // @vuese
      // Funkcja waliduje formularz, i zapisuje/nadpisuje dane w bazie
      save() {
        if (!this.$schema.$validateAll().length) {
          const model = this.prepareModel(this.$schema.$getData());
          if (this.id) {
            // Emituje event do edytowania danych
            // @arg Zwalidowany model do edycji w bazie
            this.$emit('update', { id: tryParseInt(this.id), ...model });
          } else {
            // Emituje event do zapisu danych
            // @arg Zwalidowany model do utworzenia w bazie
            this.$emit('save', model);
          }
          this.close();
        } else {
          this.notifyError(messages.formError || Errors.FORM_INCORRECTLY_COMPLETED);
        }
      },

      // @vuese
      // Ustawia dane formularza
      setData() {
        this.$schema.$setDefault();
        if (this.id) {
          this.$schema.$setData(this.stateData, undefined, true);
        }
        this.$schema.$reset();
      }
    },
    computed: mapState({
      stateData: state => state[moduleName].data
    }),
    watch: {
      // @vuese
      // Resetuje pola modala przed pokazaniem go
      show(val) {
        if (val) {
          this.setData();
        }
      }
    }
  };
}
